import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { unescape } from 'lodash';

import ElementHeightObserver from 'components/ElementHeightObserver';
import { ElementNames } from 'constants/app';
import { iconsBranding, mobileIcons } from 'constants/branding';
import useDevice from 'hooks/useDevice';
import { getIsIframeEnabled } from 'redux/modules/appConfigs/selectors';
import { getElementHeightByName } from 'redux/modules/appSettings/selectors';
import { getBackendPageData } from 'redux/modules/pages/selectors';

import commonStyles from '../styles.module.scss';

const ResponsibleBettingSelfExclusionSuspendedTemplate = () => {
  const { isMobile } = useDevice();
  const data = useSelector(getBackendPageData);
  const isIframeEnabled = useSelector(getIsIframeEnabled);
  const headerHeight = useSelector(getElementHeightByName(ElementNames.HEADER_HEIGHT));
  const footerHeight = useSelector(getElementHeightByName(ElementNames.FOOTER_HEIGHT));

  const hasMinHeightStyle = !(isMobile && isIframeEnabled);
  const minHeightStyle = hasMinHeightStyle ? { minHeight: `calc(100vh - ${headerHeight + footerHeight}px)` } : {};

  return (
    <ElementHeightObserver
      className={classNames(commonStyles.container, {
        [commonStyles.container__mobile]: isMobile
      })}
      style={{
        ...minHeightStyle
      }}
    >
      <div className={commonStyles.content}>
        <div className={commonStyles.iconWrapper}>
          <i
            className={classNames(
              commonStyles.icon,
              commonStyles.icon__unlocked,
              'biab_custom-icon-unlocked',
              isMobile ? mobileIcons.OPEN_LOCK_ICON : iconsBranding.OPEN_LOCK_ICON
            )}
          />
        </div>
        <h3 className={commonStyles.title}>{data?.name}</h3>
        <div className={commonStyles.description} dangerouslySetInnerHTML={{ __html: unescape(data?.content ?? '') }} />
      </div>
    </ElementHeightObserver>
  );
};

export default ResponsibleBettingSelfExclusionSuspendedTemplate;
